module.exports = __webpack_public_path__ + "static/media/report_Icon.c53e215a.svg";